import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import { MainScreenContact, StartConversation } from '@/components/contact'
import { useTheme } from '@cellectenergy/cellect-react-components'
import { Spacer } from '@/components/ui/spacer'
import { SaleForce } from '@/components/contact/support/SaleForce'
import MainLayout from '@/layouts/MainLayout'

const Contact = () => {
  const theme = useTheme()

  const saleForce = [
    {
      name: 'Hedy Mahmoudi',
      email: 'h.mahmoudi@cellectenergy.com',
      position: 'expert',
      region: '',
      image: '/assets/contact/support/expert2.png',
      linkedin: 'https://www.linkedin.com/in/hedy-mahmoudi/',
      calendly:
        'https://outlook.office.com/bookwithme/user/f2fbc6354eff4715aa4e6c7693db5386%40cellectenergy.com?anonymous',
    },
    {
      name: 'David Vadillo',
      email: 'd.vadillo@cellectenergy.com',
      position: 'expert',
      region: '',
      image: '/assets/contact/support/expert3.png',
      linkedin: 'https://www.linkedin.com/in/davidvadillo/',
      calendly:
        ' https://outlook.office.com/bookwithme/user/8d9bd876445e47caa4b5aaa91f378d13%40cellectenergy.com?anonymous',
    },
  ]

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Le_NVQiAAAAAICg36Gi-LIbY9IbaXORJl0eVCop"
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <MainLayout
        bgTheme={theme.palette.common.corporateColors.primary.midNightBlue}
        navbarTheme="light"
        title="Contact"
        description="Contact is a page where the client can contact an advisor to know about the product/services"
      >
        <MainScreenContact />
        {/* <SaleForce saleForce={saleForce} />
        <Spacer
          bgColor={theme.palette.common.corporateColors.secondary.turquoise}
          width={{
            xs: '100%',
            md: 'calc(1024px - 4rem)',
            lg: 'calc(1440px - 4rem)',
          }}
          height="1px"
        /> */}

        <Spacer
          bgColor={theme.palette.common.corporateColors.secondary.turquoise}
          width={{
            xs: '100%',
            md: 'calc(1024px - 4rem)',
            lg: 'calc(1440px - 4rem)',
          }}
          height="1px"
        />
        <StartConversation />
      </MainLayout>
    </GoogleReCaptchaProvider>
  )
}

export default Contact
